module.exports = __webpack_public_path__ + "media/snare.8a0ccd5d.wav";